var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "22 22 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 34C26 30.6863 28.6863 28 32 28H64C67.3137 28 70 30.6863 70 34V41C67.7909 41 66 42.7909 66 45C66 47.2091 67.7909 49 70 49V62C70 65.3137 67.3137 68 64 68H32C28.6863 68 26 65.3137 26 62V49C28.2091 49 30 47.2091 30 45C30 42.7909 28.2091 41 26 41V34Z",
    fill: "#14532D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39H57",
    stroke: "#C4F82A",
    strokeWidth: 4.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 48H54",
    stroke: "#C4F82A",
    strokeWidth: 4.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 57H49",
    stroke: "#C4F82A",
    strokeWidth: 4.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 54.5,
    r: 7.5,
    fill: "#FF6B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavLogo);
export default __webpack_public_path__ + "static/media/nav-logo.d10113e918f763c0014cc505fe3462bf.svg";
export { ForwardRef as ReactComponent };